<template lang="pug">
Auth(@loggedIn="onLoggedIn" @loginFailed="onFailedAuthentication")
  Header(:content="headerContent")
  ModalPage(
    ref="modalPage"
    v-if="uid",
    @closeModalPage="closeModalPage",
    :modalPageContentId="modalPageContentId",
    :showModal="showModalPage")
  ModalWindow(
    @closeModal="closeModalWindow",
    modalContentId="tmp",
    :showModal="showModalWindow")
  div.wrap-trainee-calendar.f.fh
    ModuleCalendar
    //- div
      p(@click="$router.push('/home/id')") to modal page
      p(@click="logout") Sign Out
</template>

<style lang="scss" scoped>
.wrap-trainee-calendar {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import db, { env } from "@/components/utils/firebase"
import { createNamespacedHelpers } from "vuex"
import Auth from "@/components/auth"
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers("auth")
import Header from "@/components/shared/Header"
import ModalWindow from "@/components/shared/ModalWindow"
import ModalPage from "@/components/shared/ModalPage"
import ModuleCalendar from "@/components/module/ModuleCalendar"

export default {
  components: {
    Auth,
    Header,
    ModalWindow,
    ModalPage,
    ModuleCalendar
  },
  computed: {
    ...mapStateAuth(['uid']),
    env: function () {
      return env
    }
  },
  data () {
    return  {
      trainee: null,
      modalPageContentId: "",
      showModalPage: false,
      showModalWindow: false,
      headerContent: {},
      rootHeaderContent: {
        label: 'カレンダー',
        leftAction: {
          icon: 'event',
          color: (env.indexOf('asc') > -1) ? "#45bad5" : "#0099d7",
          method: () => {
            this.$router.push("/calendar")
          }
        },
        rightAction: {
          icon: 'account_circle',
          color: (env.indexOf('asc') > -1) ? "#45bad5" : "#0099d7",
          method: () => {
            this.$router.push(`/trainee/${this.uid}`)
          }
        }
      }
    }
  },
  async created () {
    this.headerContent = this.rootHeaderContent
    this.routeModalPage()
  },
  watch: {
    '$route': function (to, from) {
      this.routeModalPage()
    }
  },
  methods: {
    ...mapActionsAuth(["signOut"]),
    async onLoggedIn () {
      this.trainee = await db.collection("TRAINEE")
        .doc(this.uid)
        .get()
        .then(d => { return d.data() })
      
      if (!this.trainee.completeTutorial) {
        console.log("to tutorial")
        this.$router.push("/tutorial")
        return true
      }
      if (!this.trainee.counseling) {
        console.log("to counceling")
        return true
      }
    },
    logout () {
      this.signOut()
      setTimeout(() => {
        this.$router.push("/sign-in")
      }, 400)
    },
    onFailedAuthentication () {
      this.$router.push("/sign-in")
    },
    onHeaderRight () {
      console.log("on right")
    },
    closeModalPage () {
      this.showModalPage = false
    },
    closeModalWindow () {
      this.showModalWindow = false
    },
    async routeModalPage () {
      this.headerContent = {}
      console.log("name:", this.$route.name)
      if (this.$route.name === "trainee-detail-event") {
        this.showModalPage = true
        this.modalPageContentId = "detail_event"
        this.headerContent = {
          label: "イベント",
          leftAction: {
            icon: "navigate_before",
            method: () => {
              this.$router.push("/calendar")
            }
          }
        }
      } else {
        this.showModalPage = false
        this.modalPageContentId = ""
        this.headerContent = this.rootHeaderContent
      }
    }
  }
}
</script>
